
import React from 'react';

const ICON_MAP = {
  'home':         'fa-solid fa-house',
  'dashboard':    'fa-solid fa-gauge',
  'menu':         'fa-solid fa-bars',
  'close':        'fa-solid fa-xmark',
  'back':         'fa-solid fa-arrow-left',
  'forward':      'fa-solid fa-arrow-right',
  'search':       'fa-solid fa-magnifying-glass',
  'filter':       'fa-solid fa-sliders',
  'sort':         'fa-solid fa-sort',
  'settings':     'fa-solid fa-gear',
  'edit':         'fa-solid fa-pen-to-square',
  'delete':       'fa-solid fa-trash',
  'trash':        'fa-solid fa-trash',
  'instagram':    'fa-brands fa-instagram',
  'facebook':     'fa-brands fa-facebook',
  'refresh':      'fa-solid fa-rotate-right',
  'add':          'fa-solid fa-plus',
  'check':        'fa-solid fa-check',
  'x':            'fa-solid fa-xmark',
  'eye':          'fa-solid fa-eye',
  'send':         'fa-solid fa-paper-plane',
  'download':     'fa-solid fa-download',
  'upload':       'fa-solid fa-upload',
  'copy':         'fa-regular fa-copy',
  'reset':        'fa-solid fa-rotate-left',
  'info':         'fa-solid fa-circle-info',
  'warning':      'fa-solid fa-triangle-exclamation',
  'error':        'fa-solid fa-circle-exclamation',
  'success':      'fa-solid fa-circle-check',
  'lock':         'fa-solid fa-lock',
  'unlock':       'fa-solid fa-lock-open',
  'chevron-down': 'fa-solid fa-chevron-down',
  'chevron-up':   'fa-solid fa-chevron-up',
  'chevron-right':'fa-solid fa-chevron-right',
  'dots':         'fa-solid fa-ellipsis',

  'scissors':     'fa-solid fa-scissors',
  'salon':        'fa-solid fa-store',
  'barber':       'fa-solid fa-user-tie',
  'appointment':  'fa-solid fa-calendar-check',
  'calendar':     'fa-solid fa-calendar',
  'calendar-day': 'fa-solid fa-calendar-day',
  'clock':        'fa-regular fa-clock',
  'timer':        'fa-solid fa-stopwatch',
  'time-slot':    'fa-solid fa-calendar-plus',

  'user':         'fa-solid fa-user',
  'users':        'fa-solid fa-users',
  'user-plus':    'fa-solid fa-user-plus',
  'admin':        'fa-solid fa-user-shield',
  'franchisee':   'fa-solid fa-briefcase',
  'client':       'fa-regular fa-circle-user',
  'staff':        'fa-solid fa-id-card',

  'money':        'fa-solid fa-money-bill-wave',
  'revenue':      'fa-solid fa-chart-line',
  'price':        'fa-solid fa-tag',
  'wallet':       'fa-solid fa-wallet',

  'star':         'fa-solid fa-star',
  'star-empty':   'fa-regular fa-star',
  'star-half':    'fa-solid fa-star-half-stroke',
  'review':       'fa-solid fa-comment-dots',
  'thumbs-up':    'fa-solid fa-thumbs-up',

  'chat':         'fa-solid fa-comments',
  'message':      'fa-solid fa-comment',
  'email':        'fa-solid fa-envelope',
  'phone':        'fa-solid fa-phone',
  'notification': 'fa-solid fa-bell',

  'pending':      'fa-solid fa-hourglass-half',
  'confirmed':    'fa-solid fa-circle-check',
  'rejected':     'fa-solid fa-circle-xmark',
  'completed':    'fa-solid fa-circle-check',
  'cancelled':    'fa-solid fa-ban',
  'active':       'fa-solid fa-circle',
  'inactive':     'fa-regular fa-circle',

  'location':     'fa-solid fa-location-dot',
  'map':          'fa-solid fa-map',

  'product':      'fa-solid fa-box',
  'service':      'fa-solid fa-wand-magic-sparkles',
  'package':      'fa-solid fa-cube',
  'category':     'fa-solid fa-layer-group',
  
  'heart':        'fa-solid fa-heart',
  'heart-empty':  'fa-regular fa-heart',
  'bookmark':     'fa-solid fa-bookmark',
  'tag':          'fa-solid fa-tag',
  'stats':        'fa-solid fa-chart-bar',
  'overview':     'fa-solid fa-table-columns',
  'list':         'fa-solid fa-list',
  'grid':         'fa-solid fa-grip',
  'doc':          'fa-solid fa-file-lines',
  'franchise':    'fa-solid fa-sitemap',
  'application':  'fa-solid fa-file-signature',
  'key':          'fa-solid fa-key',
  'gender-male':  'fa-solid fa-mars',
  'gender-female':'fa-solid fa-venus',
  'rating':       'fa-solid fa-medal',
  'area':         'fa-solid fa-ruler-combined',
  'reload':       'fa-solid fa-arrows-rotate',
  'external':     'fa-solid fa-arrow-up-right-from-square',
};

const SIZE_MAP = {
  'xs':   '0.75em',
  'sm':   '0.875em',
  '':     '1em',
  'md':   '1em',
  'lg':   '1.25em',
  'xl':   '1.5em',
  '2x':   '2em',
  '3x':   '3em',
};

const Icon = ({ name, size = '', color, style = {}, className = '', title }) => {
  const faClass = ICON_MAP[name] || `fa-solid fa-circle-question`;
  const fontSize = SIZE_MAP[size] || size || '1em';
  return (
    <i
      className={`${faClass} ${className}`}
      style={{ fontSize, color, lineHeight: 1, ...style }}
      title={title}
      aria-hidden="true"
    />
  );
};

export default Icon;
